__turbopack_context__.v({
  "link": "Box3SG_link",
  "policyText": "Box3SG_policyText",
});
